module.exports = __webpack_public_path__ + "static/sharing-logo-1ac2b594f0c50e295ee2f42731a6800e.jpg";